<tec-modal
	[isVisible]="isVisible()"
	[title]="'SIDENAV.OPERATIONS_BALANCE_MODAL_TITLE' | translate"
	[buttonSecondaryLabel]="'SIDENAV.OPERATIONS_BALANCE_SEE_LESS' | translate"
	(closeEvent)="onClose()"
>
	<ng-container body>
		<div class="grid grid-e2">
			@for (item of items(); track item.billing_key) {
				<tec-progress
					[value]="percentOf(item)"
					[label]="'BILLING_BALANCE.KEYS.' + item.billing_key | translate"
					[description]="
						'SIDENAV.OPERATIONS_BALANCE_DESC'
							| translate: { consumed: consumedOf(item), purchased: purchasedOf(item) }
					"
				/>
			}
		</div>
	</ng-container>
</tec-modal>
